import { RotasAcademico, RotasSistema } from 'src/rotas'
import { RotasAluno } from 'src/rotas/aluno'
import { RotasParceiroCertificacao } from 'src/rotas/parceiroCertificacao'
import { RotasProfessor } from 'src/rotas/professor'
import { RotasResponsavelFinanceiro } from 'src/rotas/responsavel-financeiro'
import { UsuarioPerfil } from 'src/tipos'

import { Visao } from './tipos'

export const normalizarPerfisJwt = (
  role: keyof typeof UsuarioPerfil | Array<keyof typeof UsuarioPerfil> | undefined
): Array<keyof typeof UsuarioPerfil> => {
  if (!role) return []
  return Array.isArray(role) ? [...role] : [role]
}

export const recuperarVisaoPorPerfis = (
  perfis: Array<keyof typeof UsuarioPerfil>
): Visao => {
  if (!perfis) return null

  const arrayPerfis = Array.isArray(perfis) ? [...perfis] : [perfis]

  // Perfil exclusivo de suporte: checado antes dos demais porque a unica tela
  // disponivel para ele e a listagem de usuarios para impersonate. Durante uma
  // sessao de impersonate o token carrega os perfis do usuario-alvo (sem
  // Impersonador/ImpersonadorLeitura), entao a visao recai naturalmente na do alvo.
  if (
    arrayPerfis.includes('Impersonador') ||
    arrayPerfis.includes('ImpersonadorLeitura')
  ) {
    return Visao.Impersonador
  }

  if (
    arrayPerfis.includes('Academico') ||
    arrayPerfis.includes('Comercial') ||
    arrayPerfis.includes('Financeiro') ||
    arrayPerfis.includes('Gerencial')
  ) {
    return Visao.IPGS
  }

  if (arrayPerfis.includes('Aluno')) return Visao.Aluno

  if (arrayPerfis.includes('Professor')) return Visao.Professor

  if (arrayPerfis.includes('Parceiro')) return Visao.Parceiro

  if (arrayPerfis.includes('ResponsavelFinanceiro')) {
    return Visao.ResponsavelFinanceiro
  }

  if (arrayPerfis.includes('ParceiroCertificacao')) {
    return Visao.ParceiroCertificacao
  }

  return null
}

export const opcoesDeVisao = (
  perfis: Array<keyof typeof UsuarioPerfil>
): Array<Visao> => {
  const arrayPerfis = Array.isArray(perfis) ? [...perfis] : [perfis]
  const perfisParaSelecao = []
  if (
    arrayPerfis.includes('Academico') ||
    arrayPerfis.includes('Comercial') ||
    arrayPerfis.includes('Financeiro') ||
    arrayPerfis.includes('Gerencial')
  ) {
    perfisParaSelecao.push(Visao.IPGS)
  }

  if (arrayPerfis.includes('Aluno')) perfisParaSelecao.push(Visao.Aluno)

  if (arrayPerfis.includes('Professor')) {
    perfisParaSelecao.push(Visao.Professor)
  }

  if (arrayPerfis.includes('Parceiro')) {
    perfisParaSelecao.push(Visao.Parceiro)
  }

  if (arrayPerfis.includes('ParceiroCertificacao')) {
    perfisParaSelecao.push(Visao.ParceiroCertificacao)
  }

  if (arrayPerfis.includes('ResponsavelFinanceiro')) {
    perfisParaSelecao.push(Visao.ResponsavelFinanceiro)
  }

  return perfisParaSelecao
}

export const recuperarRotaBasePorVisao = (
  perfis: Array<keyof typeof UsuarioPerfil>
): string => {
  switch (recuperarVisaoPorPerfis(perfis)) {
    case Visao.Impersonador:
      return RotasSistema.Impersonate
    case Visao.IPGS:
    case Visao.Parceiro:
      return RotasAcademico.Dashboard
    case Visao.Aluno:
      return RotasAluno.Dashboard
    case Visao.Professor:
      return RotasProfessor.Dashboard
    case Visao.ResponsavelFinanceiro:
      return RotasResponsavelFinanceiro.Dashboard
    case Visao.ParceiroCertificacao:
      return RotasParceiroCertificacao.Dashboard
  }
}
